import Vue from 'vue'
import Vuex from 'vuex'

// 动态引入/modules 下的js
const files = require.context('./modules', false, /\.js$/)
const modules = {}
files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

Vue.use(Vuex)

const store = new Vuex.Store({
  modules
})

export default store
